//@flow

import {useState, useEffect} from 'react';

import {
  generateProductCatalogueService,
  getProductCatalogueService,
} from './promises';

import type {ProductCatalogue} from '../../entities';

const POLLING_INTERVAL = 5000;

export function useProductCatalogue() {
  const [productCatalogue, setProductCatalogue] = useState<
    ProductCatalogue | typeof undefined
  >();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | typeof undefined>();

  useEffect(() => {
    setLoading(true);
    getProductCatalogueService()
      .then(setProductCatalogue)
      .catch(e => {
        console.error(`Error getting product catalogue: ${e.message}`);
        setError('Error al obtener el catálogo de productos');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!productCatalogue) return;
    if (
      productCatalogue.state === 'BUILT' ||
      productCatalogue.state === 'FAILED'
    ) {
      return;
    }

    const interval = setInterval(() => {
      getProductCatalogueService()
        .then(setProductCatalogue)
        .catch(e => {
          console.error(`Error getting product catalogue: ${e.message}`);
          setError('Error al obtener el catálogo de productos');
        });
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [productCatalogue]);

  const generateCatalogue = () => {
    setLoading(true);
    generateProductCatalogueService()
      .then(setProductCatalogue)
      .catch(e => {
        console.error(`Error generating product catalogue: ${e.message}`);
        setError('Error al generar el catálogo de productos');
      })
      .finally(() => setLoading(false));
  };

  return {productCatalogue, loading, error, generateCatalogue};
}
